export default __webpack_public_path__ + "instagram.svg";